import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import i18n from 'i18next';
import HeaderComponent from '../../helper/Navhelp';
import classNames from 'classnames';
import navigationmenu from '../../configs/navigation.json';
import Canvas from './Canvas';
import info from "../../configs/info.json";
import LanguagePicker from "./LanguagePicker";





class Headertwo extends HeaderComponent {
    constructor(props) {
        super(props);
        this.state = {
            isHome: this.props.home,
            resize:this.setResize(),
           language:"IT"

        };

    }
    setResize(){
        const elementHeight = document.body.offsetHeight;
        const elementWidth = document.body.offsetWidth;
        if(parseInt(elementWidth)<=767){
            //this.setState({fullpage:true})
            return true
        }
        return false
    }
    handleLanguageOnChange = (lang) => {
    console.log(`${Date.now()}: ${lang}`);
};
    handleLanguageOnChangeEnd = (lang) => {
        console.log("lang ",lang)
        this.setState({language:lang})
        if(lang=="EN"){
            console.log("entrato nell'en")
            console.log(" lingua pre ",i18n.language)
            i18n.changeLanguage("en")
            console.log(" lingua after ",i18n.language)

        }
        else if(lang=="IT"){
            console.log("entrato nell'it")
            console.log(" lingua pre ",i18n.language)
            i18n.changeLanguage("it")
            console.log(" lingua after ",i18n.language)
        }


    }
    render() {
        const breakpoint = this.state.isMobile ? 'breakpoint-on' : '';
        const hideClass = this.state.isMobile ? 'd-none' : '';
        const stickyHeader = this.state.isTop ? 'sticky-active' : '';
        return ( 
            <Fragment>
                {/*====== HEADER START ======*/}

                <header className={`header-absolute ${this.state.isHome} sticky-header ${stickyHeader}`}>
                    {this.state.isTop && this.state.resize && <div className="header-banner"><b>  <a href={"tel:"+info.telToCall}>TEL: {info.telToCall}</a></b></div>}
                    <div className="container container-custom-one">
                        <div className={`nav-container d-flex align-items-center justify-content-between ${breakpoint}`}>
                            {/* Main Menu */}
                            <div className={classNames("nav-menu d-lg-flex align-items-center", { "menu-on": this.state.navmethod })}>
                                {/* Navbar Close Icon */}
                                <div className="navbar-close" onClick={this.toggleNav}>
                                    <div className="cross-wrap"><span className="top" /><span className="bottom" /></div>
                                </div>
                                {/* Off canvas Menu  */}
                                <div className="toggle" onClick={this.canvasToggle}>
                                    <Link to="#" id="offCanvasBtn"><i className="fal fa-bars" /></Link>
                                </div>
                                {/* Mneu Items */}
                                <div className="menu-items">
                                    <ul>
                                        {/*<li className={"menu-item"}>  <LanguagePicker
                                            current={this.state.language}
                                            available={["EN", "IT"]}
                                            direction={"down"}
                                            onChange={this.handleLanguageOnChange}
                                            onChangeEnd={this.handleLanguageOnChangeEnd}
                                        /></li>*/}
                                        {navigationmenu.length > 0 ? navigationmenu.map((item, i) => (
                                            <li key={i} className={`menu-item ${item.child ? 'menu-item-has-children' : ''} `} onClick={this.triggerChild}>
                                                {item.child ? <Link onClick={e => e.preventDefault()} to="/"> {item.linkText} </Link> : <Link to={item.link}> {item.linkText} </Link>}
                                                {item.child ?
                                                    <ul className="submenu" role="menu">
                                                        {item.submenu.map((sub_item, i) => (
                                                            <li key={i} className={`menu-item ${sub_item.child ? 'menu-item-has-children' : ''} `}>
                                                                {sub_item.child ? <Link onClick={e => e.preventDefault()} to="/"> {sub_item.linkText} </Link> : <Link to={sub_item.link}> {sub_item.linkText} </Link>}
                                                                {sub_item.submenu ?
                                                                    <ul className="submenu">
                                                                        {sub_item.submenu.map((third_item, i) => (
                                                                            <li className="menu-item" key={i}><Link
                                                                                to={third_item.link}>{third_item.linkText}</Link>
                                                                            </li>
                                                                        ))}
                                                                    </ul> : null}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    : null
                                                }
                                            </li>
                                        )) : null}

                                    </ul>
                                </div>
                                {/* from pushed-item */}
                                <div className="nav-pushed-item" />
                            </div>
                            {/* Site Logo */}
                            <div className="site-logo">
                                {this.state.isHome=="header-two" &&

                                    <Link to="/" className={this.state.isHome=="header-two" ? "main-logo":""}><img style={{width:"80%"}} src={process.env.PUBLIC_URL + "/assets/img/logo/scontorno/logo_bianco.svg"} alt="logo" /></Link>
                                }
                                <Link to="/" className={this.state.isHome=="header-two" ? "sticky-logo":""}><img style={{width: "80%"}}
                                                                          src={process.env.PUBLIC_URL + "/assets/img/logo/scontorno/logo_blu.svg"}
                                                                          alt="logo"/></Link>


                                </div>
                            {/* Header Info Pussed To Menu Wrap */}
                            <div className={`nav-push-item ${hideClass}`}>
                                {/* Header Info */}
                                <div className="header-info d-lg-flex align-items-center">

                                    <div className="item">
                                        <i className="fal fa-phone" />
                                        <span>Numero di telefono</span>

                                            <h5 className="title">{info.phone}</h5>

                                    </div>
                                    <div className="item">
                                        <i className="fal fa-envelope" />
                                        <span>Indirizzo Email</span>

                                            <h5 className="title">{info.email}</h5>

                                    </div>

                                </div>
                            </div>
                            {/* Navbar Toggler */}
                            <div className={classNames("navbar-toggler", { "active": this.state.navmethod })} onClick={this.toggleNav}>
                                <span /><span /><span />
                            </div>
                        </div>
                    </div>

                </header>
                {/*====== HEADER END ======*/}
                {/*====== OFF CANVAS START ======*/}
                <div className={classNames("offcanvas-wrapper", { "show-offcanvas": this.state.canvasmethod })}>
                    <div className={classNames("offcanvas-overly", { "show-overly": this.state.canvasmethod })} onClick={this.canvasToggle} />
                    <div className="offcanvas-widget">
                        <Link to="#" className="offcanvas-close" onClick={this.canvasToggle}><i className="fal fa-times" /></Link>
                        <Canvas />
                    </div>
                </div>
                {/*====== OFF CANVAS END ======*/}
            </Fragment>
        );
    }
}

export default Headertwo;